import {generateSecret, sendFormAsAjax} from './parts/functions';
import {Modal, Popover, Tooltip} from 'bootstrap';

document.addEventListener("DOMContentLoaded", function () {
    window.confirmAction = function (url, text) {
        if (!text) {
            text = "Are you sure you want to proceed?";
        }

        if (confirm(text)) {
            if (url) {
                window.location.href = url;
            }
        } else {
            event.preventDefault();
        }
    }

    window.copyToClipboard = function (element, text, target = null) {
        if (target) {
            element = document.querySelector(target);
            text = element.value;
        }

        // Hide all existing popovers
        document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {
            const existingPopover = Popover.getInstance(el);
            if (existingPopover) {
                existingPopover.hide();
            }
        });

        navigator.clipboard.writeText(text).then(() => {
            const popover = Popover.getOrCreateInstance(element);
            popover.show();
            setTimeout(() => popover.hide(), 1500);
        }).catch(err => {
            console.error('Failed to copy text: ', err);
        });
    };
    window.generateSecret = generateSecret;

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));

    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    popoverTriggerList.forEach(popoverTriggerEl => {
        new Popover(popoverTriggerEl, { trigger: 'manual' });
    });

    if (document.querySelector('.multiselectInit')) {
        document.querySelectorAll('.multiselectInit').forEach(select => {
            new TomSelect(select, {
                maxItems: null,
                maxOptions: 1000,
                plugins: {
                    'checkbox_options': {
                        'checkedClassNames':   ['ts-checked'],
                        'uncheckedClassNames': ['ts-unchecked'],
                    }
                },
                allowEmptyOption: true,
            });
        });
    }

    let salesRepSelect = document.getElementById('salesRepSelect');
    if (salesRepSelect) {
        salesRepSelect.addEventListener('change', function () {
            let urlParams = new URLSearchParams(window.location.search);
            let salesRepId = this.value;
            urlParams.set('sales_rep_id', salesRepId);
            window.location.search = urlParams.toString();
        });
    }

    if (document.querySelector(".activities") || document.querySelector(".contact-details")) {
        initializeActivitiesPage();

        let taskStartTime = document.getElementById('taskStartTime');
        if (taskStartTime) {
            $('#taskStartTime').datetimepicker({
                useCurrent: false,
                format: "hh:mma",
                stepping: 15,
                widgetPositioning: {
                    vertical: "top"
                }
            });
        }

        let editTaskStartTime = document.getElementById('taskStartTime');
        if (editTaskStartTime) {
            $('#editTaskStartTime').datetimepicker({
                useCurrent: false,
                format: "hh:mma",
                stepping: 15,
                widgetPositioning: {
                    vertical: "top"
                }
            });
        }
    }

    function initializeActivitiesPage() {
        const tsOptions = {
            allowEmptyOption: false,
            maxItems: 1,
            valueField: 'id',
            searchField: ['first_name', 'last_name', 'id', 'company_name'],
            placeholder: 'Start typing…',
            load: (query, callback) => {
                if (!query.length) return callback();

                axios.get(`/contacts`, {
                    params: { search: query },
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    }
                })
                    .then(response => {
                        const json = response.data;
                        if (json.success && Array.isArray(json.data)) {
                            const items = json.data.map(item => ({
                                id: item.id,
                                first_name: item.first_name,
                                last_name: item.last_name,
                                company_name: item.company_name,
                            }));
                            callback(items);
                        } else {
                            callback();
                        }
                    })
                    .catch(() => {
                        callback();
                    });
            },
            render: {
                option: (item, escape) => {
                    return `<div>
                          <strong>${escape(item.company_name ? item.company_name : item.first_name + ' ' + item.last_name )}</strong>
                          <small style="color:#888">[${escape(item.id)}]</small>
                        </div>`;
                },
                item: (item, escape) => {
                    return `<div>${escape(item.company_name ? item.company_name : item.first_name + ' ' + item.last_name)}</div>`;
                }
            }
        };

        const editTaskContactIdElement = document.getElementById('editTaskContactId');
        const taskContactIdElement = document.getElementById('taskContactId');
        if(taskContactIdElement) {
            new TomSelect('#taskContactId', tsOptions);
        }

        let editTaskContactIdTomSelect;

        if (editTaskContactIdElement) {
            editTaskContactIdTomSelect = new TomSelect('#editTaskContactId', tsOptions);
        }

        const batchTaskEditButton = document.getElementById("batch-task-edit-button");
        if(batchTaskEditButton) {
            batchTaskEditButton.addEventListener("click", function () {
                let editBulkActivityModal = document.getElementById("editBulkActivityModal");
                let selectedTasks = document.querySelectorAll(".task-checkbox:checked");

                if (selectedTasks.length === 0) {
                    alert("❌ Please select at least one task before editing.");
                    return;
                }

                (new Modal(editBulkActivityModal)).show();

                const selectedTaskIds = Array.from(selectedTasks).map(checkbox => checkbox.value);

                const container = document.getElementById('editTaskIDsContainer');
                container.innerHTML = '';

                selectedTaskIds.forEach(id => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'activity_ids[]';
                    input.value = id;
                    container.appendChild(input);
                });

                const selectedCountElement = editBulkActivityModal.querySelector('.selected-tasks-count');
                if (selectedCountElement) {
                    selectedCountElement.textContent = selectedTasks.length;
                }
            });
        }

        const tabs = document.querySelectorAll('.tab');
        const contents = document.querySelectorAll('.tab-content');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const targetId = tab.dataset.tab;

                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');

                contents.forEach(c => {
                    c.classList.remove('active');
                    c.style.display = 'none';
                });

                const targetContent = document.getElementById(targetId);
                if (targetContent) {
                    targetContent.classList.add('active');
                    targetContent.style.display = 'block';
                }

                if (targetId === 'tab-completed') {
                    batchTaskEditButton.classList.add('hidden');
                } else {
                    batchTaskEditButton.classList.remove('hidden');
                }
            });
        });

        window.selectDate = function(date) {
            var urlParams = new URLSearchParams(window.location.search);
            urlParams.set("date", date);  // Set the new date
            if (!urlParams.has("month")) {
                urlParams.set("month", date.substring(0, 7)); // Extract YYYY-MM from date if not already present
            }
            window.location.search = urlParams.toString();
        };

        window.changeMonth = function(offset) {
            var headerText = document.getElementById("month-header").textContent;
            var parts = headerText.split(" ");
            if (parts.length < 2) {
                console.error("Month header text is not in expected format.");
                return;
            }
            var monthName = parts[0];
            var year = parseInt(parts[1]);
            var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var monthIndex = monthNames.indexOf(monthName);
            if (monthIndex === -1) {
                console.error("Invalid month name in header:", monthName);
                return;
            }
            monthIndex += offset;
            if (monthIndex < 0) {
                monthIndex = 11;
                year -= 1;
            } else if (monthIndex > 11) {
                monthIndex = 0;
                year += 1;
            }
            const newMonthNumber = String(monthIndex + 1).padStart(2, '0');
            const newMonthName = monthNames[monthIndex];
            document.getElementById("month-header").textContent = newMonthName + " " + year;
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set("month", year + "-" + newMonthNumber);
            window.location.search = urlParams.toString();
        };

        window.editTask = function(taskId) {
            axios.get('/activities/read/' + taskId)
                .then(response => {
                    const data = response.data;
                    if (data.error) {
                        alert('Error: ' + data.error);
                    } else {
                        document.getElementById('editTaskForm').action = '/activities/' + taskId + '/edit';
                        document.getElementById('editTaskType').value = data.type;
                        document.getElementById('editTaskDate').value = data.start_date;
                        document.getElementById('editTaskStartTimeInput').value = data.start_time;
                        document.getElementById('editTaskDescription').value = data.description;

                        if (editTaskContactIdTomSelect) {
                            editTaskContactIdTomSelect.clearOptions();
                            editTaskContactIdTomSelect.clear(true);
                            if (data.contact) {
                                editTaskContactIdTomSelect.addOption({
                                    id: data.contact.id,
                                    first_name: data.contact.first_name,
                                    last_name: data.contact.last_name,
                                    company_name: data.contact.company_name
                                });
                                editTaskContactIdTomSelect.setValue(data.contact.id);
                            }
                        }

                        (new Modal(document.getElementById('editTaskModal'))).show();
                    }
                })
                .catch(error => {
                    console.error('Error fetching task:', error);
                    alert('An error occurred while fetching task data.');
                });
        };

        const addTaskForm = document.getElementById('addTaskForm');
        if (addTaskForm) {
            addTaskForm.addEventListener('submit', function(event) {
                event.preventDefault(); // Prevent the default form submission
                sendFormAsAjax(this); // Call our AJAX function, passing the form element
            });
        }

        const editTaskForm = document.getElementById('editTaskForm');
        if (editTaskForm) {
            editTaskForm.addEventListener('submit', function(event) {
                event.preventDefault(); // Prevent the default form submission
                sendFormAsAjax(this, 'patch'); // Call our AJAX function, passing the form element
            });
        }
    }
});
